import ModalView from '../../../../scripts/utils/modal-view.js';
import Urls from '../urls.js';

export default class ProductLeaseHelpView extends ModalView {
	constructor({ el, modal_selector, navigation }) {
		super({ el, modal_selector, navigation });
		this.template_url = Urls.Templates.help;
		this.render();
	}

	get_context() {
		var settings = window.SiteSettings || {};

		return {
			navigation: this.navigation,
			phone: settings.COMPANY_PHONE ? settings.COMPANY_PHONE : null
		};
	}
}